var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C5.78 19.53 4.39 20 3 20H1v2h2c1.38 0 2.74-.35 4-.99a8.753 8.753 0 008 0c1.26.65 2.62.99 4 .99h2v-2h-2zM2.95 18H3c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78a.997.997 0 00-.6-.5L19 9.62V5c0-1.1-.9-2-2-2h-3V0H8v3H5c-1.1 0-2 .9-2 2v4.62l-1.29.42a1.007 1.007 0 00-.66 1.28L2.95 18zM5 5h12v3.97L11 7 5 8.97V5z",
    fill: "#fff"
  })));
}

export default SvgBoat;